export const MEMBER_CARD_SCENE_MAP: Record<number, string> = {
    0: '商城首次消费发卡',
    1: '个人中心领卡',
    2: '收银台扫码',
    3: '员工分享',
    4: '其他来源',
}

export const MEMBER_CARD_SCENE_OPTIONS = Object.keys(MEMBER_CARD_SCENE_MAP).map(key => ({
    label: MEMBER_CARD_SCENE_MAP[Number(key)],
    value: Number(key),
}))

export const getMemberCardSceneText = (scene: number) => MEMBER_CARD_SCENE_MAP[scene] || '未知场景'
